import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Box,
  Paper,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import EngineeringIcon from '@mui/icons-material/Engineering';
import HandymanIcon from '@mui/icons-material/Handyman';
import ConstructionIcon from '@mui/icons-material/Construction';
import ArchitectureIcon from '@mui/icons-material/Architecture';

const Services = () => {
  const services = [
    {
      title: 'Δομοστατική Μηχανική',
      description: `Οι υπηρεσίες δομικής μηχανικής μας εξασφαλίζουν την ασφάλεια και τη σταθερότητα των κτιρίων και των υποδομών. Παρέχουμε ολοκληρωμένη ανάλυση, σχεδιασμό και διαβούλευση για:
        • Δομές κτιρίων
        • Γέφυρες και τούνελ
        • Συστήματα θεμελίωσης
        • Σεισμικό σχεδιασμό
        • Δομικές εκτιμήσεις`,
      icon: <EngineeringIcon sx={{ fontSize: 60 }} />,
      color: '#3f51b5'
    },
    {
      title: 'Διαχείριση Έργων',
      description: `Εξειδικευμένες υπηρεσίες διαχείρισης έργων για να εξασφαλίσουμε την ολοκλήρωση του έργου σας εγκαίρως και εντός προϋπολογισμού. Οι υπηρεσίες μας περιλαμβάνουν:
        • Σχεδιασμό και προγραμματισμό έργων
        • Εκτίμηση και έλεγχο κόστους
        • Διαχείριση ποιότητας
        • Αξιολόγηση κινδύνων
        • Συντονισμό κατασκευών`,
      icon: <ArchitectureIcon sx={{ fontSize: 60 }} />,
      color: '#009688'
    },
    {
      title: 'Επίβλεψη Κατασκευών',
      description: `Επαγγελματική επίβλεψη κατασκευών για τη διατήρηση της ποιότητας και τη συμμόρφωση κατά τη διαδικασία κατασκευής:
        • Επιθεώρηση και παρακολούθηση εργοταξίου
        • Έλεγχο ποιότητας
        • Συμμόρφωση με ασφάλεια
        • Αναφορά προόδου
        • Τεχνική τεκμηρίωση`,
      icon: <ConstructionIcon sx={{ fontSize: 60 }} />,
      color: '#e64a19'
    },
    {
      title: 'Σχεδιασμός Υποδομών',
      description: `Ολοκληρωμένες υπηρεσίες σχεδιασμού υποδομών για δημόσια και ιδιωτικά έργα:
        • Σχεδιασμός οδών και αυτοκινητοδρόμων
        • Συστήματα ύδρευσης
        • Συστήματα αποχέτευσης
        • Πολεοδομικός σχεδιασμός
        • Περιβαλλοντικές εκτιμήσεις`,
      icon: <HandymanIcon sx={{ fontSize: 60 }} />,
      color: '#455a64'
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Οι Υπηρεσίες μας
      </Typography>
      <Typography
        variant="h6"
        align="center"
        color="text.secondary"
        paragraph
        sx={{ mb: 6 }}
      >
        Ολοκληρωμένες λύσεις πολιτικής μηχανικής για τις ανάγκες κατασκευής και υποδομών σας
      </Typography>

      <Grid container spacing={4}>
        {services.map((service, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card
              elevation={1}
              sx={{ 
                borderRadius: 2,
                overflow: 'hidden',
                height: '100%',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: 6,
                }
              }}
            >
              <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', textAlign: 'center', p: 3 }}>
                <Box sx={{ mb: 2, color: 'primary.main' }}>
                  {service.icon}
                </Box>
                <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
                  {service.title}
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ whiteSpace: 'pre-line', flexGrow: 1 }}
                >
                  {service.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 6, textAlign: 'center' }}>
        <Typography variant="h4" component="h2" gutterBottom>
          Χρειάζεστε τις Υπηρεσίες μας;
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Επικοινωνήστε μαζί μας σήμερα για να συζητήσουμε τις απαιτήσεις του έργου σας
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          component={RouterLink}
          to="/contact"
          sx={{
            px: 4,
            py: 1,
            borderRadius: 2,
            fontWeight: 'bold',
          }}
        >
          Επικοινωνία
        </Button>
      </Box>
    </Container>
  );
};

export default Services; 